module.exports = __webpack_public_path__ + "img/dgroup_26.f1aba652.jpg";